import { render, staticRenderFns } from "./offcanvas.vue?vue&type=template&id=22c1cfe4&"
import script from "./offcanvas.vue?vue&type=script&lang=js&"
export * from "./offcanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports